import Icon, { iconTypes } from './Icon';

export { iconTypes };
export default Icon;
